
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import BtnRadio from "@/components/scope/btn-radio.vue";
import FilterBar from "@common/src/components/scope/filter-bar.vue";
import echarts from "echarts";
import t from "@common/src/i18n/t";
import appCode from "@common/src/utils/app-code";
const statement = namespace("statement");
const base = namespace("base");
const management = namespace("management");
@Component({
  components: { BtnRadio, FilterBar },
  filters: {}
})
export default class Statement extends Vue {
  @statement.Action getCustomerSituationAnalysisModel;
  @base.Action getDictionaryList;
  @management.Action getStoreList;

  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  defaultParams: any = {
    storeCode: "S00210319LS",
    storeName: t("v210831.jiajiele-industry-(shanghai)")
  };
  searchForm: any = {
    storeCode: this.defaultParams.storeCode, // 门店名称
    area: "", // 所在地区
    stateName: "", // 省级名称
    cityName: "", // 市级名称
    districtName: "", // 县级名称
    timeFrameType: "", // 时间范围类型, date-按日,month-按月
    startTime: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    endTime: "", // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    businessType: "", // 服务类型，services-服务项目,parts-零配件
    businessCodeList: [] // 服务编码列表
  };
  contentList: any = [];
  pieChartRadio: any = "0";
  barChartRadio: any = "0";

  created() {
    if (localStorage.getItem("searchFormData")) {
      let data = JSON.parse(localStorage.getItem("searchFormData"));
      localStorage.removeItem("searchFormData");
      this.searchForm = data;
    } else {
      if (appCode === "speedbiz-operation") {
        this.searchStore("");
      }
      this.getCurrentTime();
    }
    if (appCode === "speedbiz") {
      this.searchForm.storeCode = "";
    }
    this.init();
  }
  getCurrentTime() {
    // 获取当前时间
    let timestamp = new Date().getTime() - 24 * 60 * 60 * 1000;
    let currentTime = new Date(timestamp);
    let year = String(currentTime.getFullYear());
    let month = this.addZero(currentTime.getMonth() + 1);
    let day = this.addZero(currentTime.getDate());
    this.searchForm.timeFrameType = "date";
    this.searchForm.startTime = year + month + "01";
    this.searchForm.endTime = year + month + day;
  }
  addZero(num) {
    return num < 10 ? "0" + num : String(num);
  }
  mounted() {}
  storeList: any = [];
  get searchList() {
    if (localStorage.getItem("searchListData")) {
      let data = JSON.parse(localStorage.getItem("searchListData"));
      localStorage.removeItem("searchListData");
      return data;
    }
    let storeRow = [
      {
        label: t("v210831.store-name"),
        type: "select-search",
        value: this.defaultParams.storeName,
        prop: "storeCode",
        selectList: this.storeList,
        searchFun: this.searchStore
      },
      {
        label: t("setting.region"),
        type: "area",
        value: "",
        labels: [],
        prop: "area",
        anyLevel: true,
        labelWidth: "85px"
      }
    ];
    let timeRow = [
      {
        label: t("v210831.time-frame"),
        type: "select-view",
        value: "",
        prop: "timeFrameType",
        // 时间范围区间必须是同一年
        isSameYear: true,
        selectList: [
          {
            value: "date",
            label: t("v210831.query-by-day"),
            itemValue: "",
            itemType: "daterange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMMdd"
          },
          {
            value: "month",
            label: t("v210831.query-by-month"),
            itemValue: "",
            itemType: "monthrange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMM"
          }
        ]
      }
    ];
    if (appCode === "speedbiz-operation") {
      return [...storeRow, ...timeRow];
    } else if (appCode === "speedbiz") {
      return timeRow;
    }
    return [];
  }
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  init() {
    this.getChartData();
  }
  dataLastUpdateTime: any = "";
  getChartData() {
    this.getCustomerSituationAnalysisModel(this.searchForm).then(data => {
      if (data.data.dataLastUpdateTime) {
        this.dataLastUpdateTime = data.data.dataLastUpdateTime;
      }
      let {
        payAmountStatistics,
        orderAmountStatistics,
        orderNumberStatistics,
        payAmountMonthlyList,
        orderAmountMonthlyList,
        orderNumberMonthlyList
      } = data.data;
      console.log(data.data, t("v210831.chart"));
      /**
       * @refName
       *  piePayChart  饼图 实收金额   -----payAmountStatistics
       *  pieOrderChart  饼图 订单金额   -----orderAmountStatistics
       *  pieNumberChart  饼图 台次   -----orderNumberStatistics
       *  barPayChart  柱状图 实收金额   -----payAmountMonthlyList
       *  barOrderChart  柱状图 订单金额   -----orderAmountMonthlyList
       *  barNumberChart  柱状图 台次   -----orderNumberMonthlyList
       */
      let piePayChartData = {
        data: [
          {
            name: t("v210831.new-customer-tested"),
            value: payAmountStatistics.newCheckAmount
          },
          {
            name: t("v210831.new-customer-no-test"),
            value: payAmountStatistics.newNoCheckAmount
          },
          {
            name: t("v210831.regular-customers--"),
            value: payAmountStatistics.oldCheckAmount
          },
          {
            name: t("v210831.old-customers--"),
            value: payAmountStatistics.oldNoCheckAmount
          }
        ],
        total: payAmountStatistics.totalAmount,
        text: t("v210831.total-paid-in"),
        tip: t("v210831.paid-in-amount")
      };
      this.setChart(piePayChartData, "piePayChart", "pie");
      let pieOrderChartData = {
        data: [
          {
            name: t("v210831.new-customer-tested"),
            value: orderAmountStatistics.newCheckAmount
          },
          {
            name: t("v210831.new-customer-no-test"),
            value: orderAmountStatistics.newNoCheckAmount
          },
          {
            name: t("v210831.regular-customers--"),
            value: orderAmountStatistics.oldCheckAmount
          },
          {
            name: t("v210831.old-customers--"),
            value: orderAmountStatistics.oldNoCheckAmount
          }
        ],
        total: orderAmountStatistics.totalAmount,
        text: t("v210831.total-order-amount"),
        tip: t("finance.order-amount")
      };
      this.setChart(pieOrderChartData, "pieOrderChart", "pie");
      let pieNumberChartData = {
        data: [
          {
            name: t("v210831.new-customer-tested"),
            value: orderNumberStatistics.newCheckNumber
          },
          {
            name: t("v210831.new-customer-no-test"),
            value: orderNumberStatistics.newNoCheckNumber
          },
          {
            name: t("v210831.regular-customers--"),
            value: orderNumberStatistics.oldCheckNumber
          },
          {
            name: t("v210831.old-customers--"),
            value: orderNumberStatistics.oldNoCheckNumber
          }
        ],
        total: orderNumberStatistics.totalNumber,
        text: t("v210831.summary-of-sets"),
        tip: t("v210831.number-of-sets"),
        isNumber: true
      };
      this.setChart(pieNumberChartData, "pieNumberChart", "pie");
      let barPayChartData = {
        data1: payAmountMonthlyList.map(v => v.newCustomerAmount),
        data2: payAmountMonthlyList.map(v => v.oldCustomerAmount),
        tip: payAmountMonthlyList,
        unit: t("v210801.element"),
        text: t("v210831.paid-in-amount")
      };
      this.setChart(barPayChartData, "barPayChart", "bar");
      let barOrderChartData = {
        data1: orderAmountMonthlyList.map(v => v.newCustomerAmount),
        data2: orderAmountMonthlyList.map(v => v.oldCustomerAmount),
        tip: orderAmountMonthlyList,
        unit: t("v210801.element"),
        text: t("finance.order-amount")
      };
      this.setChart(barOrderChartData, "barOrderChart", "bar");
      let barNumberChartData = {
        data1: orderNumberMonthlyList.map(v => v.newCustomerNumber),
        data2: orderNumberMonthlyList.map(v => v.oldCustomerNumber),
        tip: orderNumberMonthlyList,
        unit: t("v210831.number-of-sets"),
        isNumber: true,
        text: t("v210831.number-of-sets")
      };
      this.setChart(barNumberChartData, "barNumberChart", "bar");
    });
  }
  setChart(data, refName, type) {
    let MyChart = echarts.init(this.$refs[refName]);
    let options = {};
    if (type === "pie") {
      // 饼图pie
      options = {
        color: ["#2278F5", "#599AFA", "#FFC300", "#FF9900"],
        tooltip: {
          trigger: "item",
          formatter: params => {
            return `${params.name}<br/>${data.tip}: ${
              data.isNumber ? params.value : this.$localMark.currencySymbol + splitThousands(params.value)
            }(${params.percent}%)`;
          }
        },
        legend: {
          bottom: "0%",
          left: "center",
          x: "center",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 24
        },
        title: {
          show: true,
          text: data.text,
          subtext: splitThousands(data.total),
          top: "43%",
          left: "center",
          textStyle: {
            color: "rgba(0, 0, 0, 0.45)",
            fontWeight: 400,
            fontSize: 12
          },
          subtextStyle: {
            color: "rgba(0, 0, 0, 0.85)",
            fontWeight: 500,
            fontSize: 18
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            data: data.data
          }
        ]
      };
    } else if (type === "bar") {
      // 柱状图bar
      options = {
        color: ["#2278F5", "#FFC300"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: params => {
            // console.log(params);
            let str = `${data.tip[params[0].dataIndex].monthParam}<br/>`;
            params.forEach(item => {
              str += `${item.marker}${item.seriesName}${data.text}: ${
                Number(item.value)
                  ? data.isNumber
                    ? item.value
                    : this.$localMark.currencySymbol + splitThousands(item.value)
                  : "-"
              }<br/>`;
            });
            return str;
          }
        },
        legend: {
          data: [t("v210831.new-customers"), t("v210831.old-customers")],
          bottom: "0%",
          left: "center",
          x: "center",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 24
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true
            },
            data: [
              t("v210831.january"),
              t("v210831.february"),
              t("v210831.march"),
              t("v210831.april"),
              t("v210831.may"),
              t("v210831.june"),
              t("v210831.july"),
              t("v210831.august"),
              t("v210831.september"),
              t("v210831.october"),
              t("v210831.november"),
              t("v210831.december")
            ]
          }
        ],
        yAxis: [
          {
            name: t("v210831.company:") + data.unit,
            axisTick: { show: false },
            type: "value"
          }
        ],
        series: [
          {
            name: t("v210831.new-customers"),
            type: "bar",
            barGap: 0,
            data: data.data1
          },
          {
            name: t("v210831.old-customers"),
            type: "bar",
            data: data.data2
          }
        ]
      };
    }
    MyChart.setOption(options);
    window.addEventListener("resize", () => {
      MyChart.resize();
    });
  }
  handlePieChange(value) {
    this.pieChartRadio = value;
  }
  handleBarChange(value) {
    this.barChartRadio = value;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "area") {
          this.searchForm.stateName = item.labels[0] || "";
          this.searchForm.cityName = item.labels[1] || "";
          this.searchForm.districtName = item.labels[2] || "";
        } else if (item.prop === "storeCode" && item.value === this.defaultParams.storeName) {
          this.searchForm[item.prop] = this.defaultParams.storeCode;
        } else {
          this.searchForm[item.prop] = item.value;
        }
        if (item.type === "select-view") {
          item.selectList.forEach(val => {
            if (val.value === item.value) {
              if (val.itemProp === "dateValue") {
                this.searchForm.startTime = val.itemValue[0] || "";
                this.searchForm.endTime = val.itemValue[1] || "";
              } else {
                this.searchForm[val.itemProp] = val.itemValue;
              }
            }
          });
        }
      }
    });
    this.getChartData();
  }
}
